import { Injectable } from '@angular/core';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { DataModel } from '@shared';

@Injectable()
export class CheckoutSanitizer {
	public removeDataRecordsStub(workfileRecords: DataModel[]): DataModel[] {
		return workfileRecords.filter(
			(record: DataModel) => !WorkspaceDatabaseKeys.excludedItems.includes(record.table_name)
		);
	}

	public toLowerCase(workfileRecord: DataModel): DataModel {
		const dataRecords: DataModel = {};

		Object.entries(workfileRecord)
			/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
			.filter(([_, v]: [string, DataModel]) => v)
			.forEach(([columnName, v]: [string, string | number | boolean]) => {
				dataRecords[columnName.toLowerCase()] = v;
			});

		return dataRecords;
	}
}
